// extracted by mini-css-extract-plugin
export var chip = "_e0-0";
export var filterDropdown = "_e0-5";
export var filterItem = "_e0-6";
export var icon = "_e0-1";
export var removeButton = "_e0-3";
export var removeIcon = "_e0-4";
export var separator = "_e0-2";